import { ethers, utils } from 'ethers';
import { BigNumber as BigNumberEth } from '@ethersproject/bignumber';
import { Contract } from '@ethersproject/contracts'
import BigNumber from 'bignumber.js'
import { BOOSTED_FARM_GAS_LIMIT, DEFAULT_TOKEN_DECIMAL } from 'config'
import { fetchFarmUserEarnings } from 'state/farms/fetchFarmUser';
import { SerializedFarmConfig } from '@pancakeswap/farms';
import { ChainId } from '@pancakeswap/sdk';

const options = {
  gasLimit: BOOSTED_FARM_GAS_LIMIT,
}

export const stakeFarm = async (masterChefContract: Contract, pid, amount, gasPrice) => {
  const value = new BigNumber(amount).times(DEFAULT_TOKEN_DECIMAL).toString()

  // return masterChefContract.deposit(pid, value, { ...options, gasPrice })
  return masterChefContract.deposit(pid, value, { ...options })
}

export const unstakeFarm = async (masterChefContract, pid, amount, gasPrice) => {
  const value = new BigNumber(amount).times(DEFAULT_TOKEN_DECIMAL).toString()

  // return masterChefContract.withdraw(pid, value, { ...options, gasPrice })
  return masterChefContract.withdraw(pid, value, { ...options })
}

export const harvestFarm = async (masterChefContract, pid, gasPrice) => {
  // return masterChefContract.deposit(pid, '0', { ...options, gasPrice })
  return masterChefContract.deposit(pid, '0', { ...options })
}

export const compoundFarm = async (masterChefContract, pid, gasPrice) => {
  const res = await fetchFarmUserEarnings(masterChefContract.signer._address, [{ pid } as SerializedFarmConfig], ChainId.BSC)
  const parsedEarning = ethers.utils.parseUnits(res[0].toString(), 'ether')
  // return masterChefContract.deposit(pid, parsedEarning, { ...options, gasPrice })
  return masterChefContract.deposit(pid, parsedEarning, { ...options })
}

export const harvestAndStakeFarm = async (masterChefContract, pid, gasPrice) => {
  const res = await fetchFarmUserEarnings(masterChefContract.signer._address, [{ pid } as SerializedFarmConfig], ChainId.BSC)
  const parsedEarning = ethers.utils.parseUnits(res[0].toString(), 'ether')
  console.log(`STEP 1 - Deposit 0 - Get ALB Profit ${parsedEarning}`)
  // await masterChefContract.deposit(pid, '0', { ...options, gasPrice });
  await masterChefContract.deposit(pid, '0', { ...options });
  const stakeAlbPid = 0;
  console.log(`STEP 2 - Deposit ${parsedEarning} to pid 0`)
  // return masterChefContract.deposit(stakeAlbPid, parsedEarning, { ...options, gasPrice })
  return masterChefContract.deposit(stakeAlbPid, parsedEarning, { ...options })
}